<div class="asm-expire-modal">
  <div class="asm-expire-modal_content -before-finish" *ngIf="beforeMode; else finish">
    <div class="asm-expire-modal_title">
      {{'modal.asmExpire.header.text' | translate}} <b *ngIf="counter>=0">{{counter|formatCounter}}</b>
    </div>
    <p class="asm-expire-modal_description">
      {{'modal.asmExpire.description.text' | translate}}
    </p>
    <div class="asm-expire-modal_buttons">
        <button
          class="asm-expire-modal_logout"
          (click)="logoutAsmUser()"
          [disabled]="logoutDisabled">
            {{'modal.asmExpire.logout.text' | translate}}
        </button>
        <button
          class="asm-expire-modal_refresh"
          (click)="resetCounter()">
            {{'modal.asmExpire.extend.text' | translate}}
        </button>
    </div>
  </div>
  <ng-template class="asm-expire-modal_content -finish" #finish>
    <div class="asm-expire-modal_content -finish">
      <div class="asm-expire-modal_title">
        {{'modal.asmExpire.finish.header.text' | translate}}
      </div>
      <p class="asm-expire-modal_description">
        {{'modal.asmExpire.finish.description.text' | translate}} {{agentTimer / 60}} {{'modal.asmExpire.finish.description2.text' | translate}}
      </p>
      <button
        class="asm-expire-modal_login"
        (click)="login()"
        [disabled]="logoutDisabled">
        {{'modal.asmExpire.finish.login.text' | translate}}
      </button>
    </div>
  </ng-template>
</div>


